var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.61 14.61"}},[_c('circle',{attrs:{"cx":"7.3","cy":"7.3","r":"7.3"}}),_c('text',{attrs:{"transform":"translate(6.12 10.11)"}},[_vm._v("i")])])}
var staticRenderFns = []

export { render, staticRenderFns }